import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pin-input',
  templateUrl: './pin-input.component.html',
  styleUrls: ['./pin-input.component.scss'],
})
export class PinInputComponent {
  @Input() pin: string[] = [];
  @Output() pinSubmitted = new EventEmitter<string>();
  @Output() pinCleared = new EventEmitter<void>();
  @Input() errorMessage: string = null;

  submitPin() {
    const fullPin = this.pin.join('');
    this.pinSubmitted.emit(fullPin);
  }

  clearPin() {
    this.pinCleared.emit();
  }
  restrictFocus(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      event.stopPropagation();
    }
  }
}
